<template>
    <div 
        class="modal fade" 
        data-keyboard="false" 
        data-backdrop="true"
    >
        <div :class="[`modal-${props.size || 'md'}`, 'modal-dialog modal-dialog-centered']">
            <component 
                v-if="modal"
                :is="modal" 
                v-bind="props" 
                v-on="listeners" 
            />
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'

    export default {
        data: () => ({
            element: null,
            modal: null,
            listeners: {},
            props: {}
        }),

        methods: {
            open({ modal, listeners, props, fromBuilder }) {
                this.element = fromBuilder ? $(this.$el) : window.$(this.$el)
                this.modal = modal
                this.listeners = listeners
                this.props = props
                this.element.modal('show')
            },

            close() {
                this.modal = null
                this.listeners = {}
                this.props = {}
                this.element.modal('hide')
            }
        },

        beforeMount() {
            this.$modal.$on('modal.open', this.open)
            this.$modal.$on('modal.close', this.close)
        },

        beforeDestroy() {
            this.$modal.$off('modal.open', this.open)
            this.$modal.$off('modal.close', this.close)
            this.element = null
        }
    }
</script>

<style lang="scss" scoped>
    .modal-dialog {
        max-width: 100% !important;
    }

    .modal-title {
        width: 100%;
        font-size: 35px;
        font-family: Roboto-Light;
    }

    .modal-title h1 {
        margin: 0 !important;
    }

    .modal-header {
        text-align: left;
        margin: 0 20px !important;
        border-bottom: 5px solid #000;
        padding: 20px 0 5px 5px !important;
    }

    .modal-body {
        margin: 0 20px !important;
    }

    .modal-xl {
        margin: auto;
        width: 90% !important;
    }

    .modal-lg {
        margin: auto;
        width: 70% !important;
    }

    .modal-md {
        margin: auto;
        width: 50% !important;
    }

    .modal-sm {
        margin: auto;
        width: 30% !important;
    }

    .modal-xs {
        margin: auto;
        width: 10% !important;
    }
</style>
